<pas-tabset [routerParam]="routerParamName" [paramMode]="'path'" (tabChange)="onChangingTab($event)">
  <pas-tab [id]="BOOKING_OVERVIEW_TAB">
    <ng-template pasTabTitle>
      <b>{{ 'RECOURSE_BOOKING_TAB_TITLE' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <app-recourse-booking></app-recourse-booking>
    </ng-template>
  </pas-tab>

  <pas-tab [id]="DETAILS_TAB" [disabled]="detailsTabDisabled" [hidden]="detailsTabHidden">
    <ng-template pasTabTitle>
      <b>{{ 'BOOKING_DETAILS_TAB_TITLE' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <recourse-booking-add-edit-details></recourse-booking-add-edit-details>
    </ng-template>
  </pas-tab>

  <pas-tab [id]="EDIT_TAB" [disabled]="editTabDisabledAndHidden" [hidden]="editTabDisabledAndHidden">
    <ng-template pasTabTitle>
      <b>{{ 'EDIT_BOOKING_TAB_TITLE' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <recourse-booking-add-edit-details></recourse-booking-add-edit-details>
    </ng-template>
  </pas-tab>

  <pas-tab [id]="NEW_TAB" [disabled]="newTabDisabledAndHidden" [hidden]="newTabDisabledAndHidden">
    <ng-template pasTabTitle>
      <b>{{ 'ADD_NEW_BOOKING_TAB_TITLE' | translate }}</b>
    </ng-template>
    <ng-template pasTabContent>
      <recourse-booking-add-edit-details></recourse-booking-add-edit-details>
    </ng-template>
  </pas-tab>
</pas-tabset>
